import { render, staticRenderFns } from "./baiFang.vue?vue&type=template&id=4f38ab9c&scoped=true&"
import script from "./baiFang.vue?vue&type=script&lang=js&"
export * from "./baiFang.vue?vue&type=script&lang=js&"
import style0 from "./baiFang.vue?vue&type=style&index=0&id=4f38ab9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38ab9c",
  null
  
)

export default component.exports